import styled, { css } from 'styled-components';
import tw from 'twin.macro';

export const ParamFormFieldContainer = styled.div`
  width: 100%;
  display: ${(props) => (props.isHidden ? 'none' : 'block')};

  ${(props) => props.css}
`;
